import { HttpStatusCode } from 'data/protocols/http';
import {
  InvalidCredentialsError,
  NotFoundError,
  UnexpectedError,
} from 'domain/errors';
import { CreateApiKeyUseCaseInterface } from 'domain/usecases';

export class RemoteCreateApiKey implements CreateApiKeyUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: Parameters<CreateApiKeyUseCaseInterface['execute']>[0],
  ): Promise<CreateApiKeyUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFoundError(httpResponse.body?.message);
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
